import type { ReactNode } from 'react';

export interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  /** Right-aligned slot (e.g. toggle, badge, button). */
  action?: ReactNode;
}

/**
 * Tight header for each section card on the publish page so the form
 * has a consistent visual rhythm without dropping a `<Card.Header />`
 * level of nesting for every block.
 */
export function SectionHeader({ title, subtitle, action }: SectionHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="text-sm font-semibold text-gray-900">{title}</div>
        {subtitle && <div className="text-xs text-gray-500 mt-0.5">{subtitle}</div>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
